// extracted by mini-css-extract-plugin
module.exports = {"title":"Categories_title__tOQlC"};